var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FormTemplate } from 'packages/form/entities/legacy/FormTemplate';
import { AbstractRepository } from 'packages/core/AbstractRepository';
import { EntityBuilder } from '@decahedron/entity';
var FormTemplateRepository = /** @class */ (function (_super) {
    __extends(FormTemplateRepository, _super);
    function FormTemplateRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.url = 'api/v2/forms/templates';
        _this.entity = FormTemplate;
        return _this;
    }
    FormTemplateRepository.prototype.listForCompany = function (companyId, version) {
        return this.get(this.url, null, {
            'filters[company_id]': companyId,
            'filters[version]': version,
        }).then(function (response) { return (EntityBuilder.buildMany(FormTemplate, response.data.data)); });
    };
    FormTemplateRepository.prototype.getTemplate = function (templateUuid) {
        return this.find(templateUuid);
    };
    FormTemplateRepository.prototype.createFormTemplate = function (formTemplate) {
        return this.post(this.url, formTemplate).then(function (response) { return EntityBuilder.buildOne(FormTemplate, response); });
    };
    return FormTemplateRepository;
}(AbstractRepository));
export { FormTemplateRepository };
